export default {
    generalPractitioners: (state) => {
        return state.generalPractitioners
    },
    getGeneralPractitionerById: (state) => {
        return (id) => state.generalPractitioners[id]
    },
    practices: (state) => {
        return state.practices
    },
    getPracticeById: (state) => {
        return (id) => state.practices[id]
    },
    state: (state) => {
        return state.state
    },
    getStateById: (state) => {
        return (id) => state.states[id]
    },
    getStateByCode: (state, getters) => {
        return (code) =>
            getters.states.first(
                (s) => (s.shortName || '').toLowerCase() == (code || '').toLowerCase()
            )
    },
    states: (state) => {
        var response = Object.values(state.states)
        return response
    },
    disease: (state) => {
        return state.disease
    },
    getDiseaseById: (state) => {
        return (id) => state.diseases[id]
    },
    diseases: (state) => {
        var response = Object.values(state.diseases)
        return response
    },
    gender: (state) => {
        return state.gender
    },
    getGenderById: (state) => {
        return (id) => state.genders[id]
    },
    getGenderByText: (state, getters) => {
        return (text) =>
            getters.genders.first((s) => (s.name || '').toLowerCase() == (text || '').toLowerCase())
    },
    genders: (state) => {
        var response = Object.values(state.genders)
        return response
    },
    indigenous: (state) => {
        return state.indigenous
    },
    getIndigenousById: (state) => {
        return (id) => state.indigenousOptions[id]
    },
    getIndigenousByText: (state, getters) => {
        return (text) =>
            getters.indigenousOptions.first(
                (s) => (s.name || '').toLowerCase() == (text || '').toLowerCase()
            )
    },
    indigenousOptions: (state) => {
        var response = Object.values(state.indigenousOptions)
        return response
    },
    urgency: (state) => {
        return state.urgency
    },
    getUrgencyById: (state) => {
        return (id) => state.urgencies[id]
    },
    urgencies: (state) => {
        var response = Object.values(state.urgencies)
        return response
    },
    requestStatus: (state) => {
        return state.requestStatus
    },
    getRequestStatusById: (state) => {
        return (id) => state.requestStatuses[id]
    },
    requestStatuses: (state) => {
        var response = Object.values(state.requestStatuses)
        return response
    },
    serviceTaskStatus: (state) => {
        return state.serviceTaskStatus
    },
    getServiceTaskStatusById: (state) => {
        return (id) => state.serviceTaskStatuses[id]
    },
    serviceTaskStatuses: (state) => {
        var response = Object.values(state.serviceTaskStatuses)
        return response
    },
    discipline: (state) => {
        return state.discipline
    },
    getDisciplineById: (state) => {
        return (id) => state.disciplines[id]
    },
    disciplines: (state) => {
        var response = Object.values(state.disciplines)
        return response
    },
    team: (state) => {
        return state.team
    },
    getTeamById: (state) => {
        return (id) => state.teams[id]
    },
    teams: (state) => {
        var response = Object.values(state.teams)
        return response
    },
    costCentre: (state) => {
        return state.costCentre
    },
    getCostCentreById: (state) => {
        return (id) => state.costCentres[id]
    },
    costCentres: (state) => {
        var response = Object.values(state.costCentres)
        return response
    },
    role: (state) => {
        return state.role
    },
    getRoleById: (state) => {
        return (id) => state.roles[id]
    },
    roles: (state) => {
        var response = Object.values(state.roles)
        return response
    },
    taskType: (state) => {
        return state.taskType
    },
    getTaskTypeById: (state) => {
        return (id) => state.taskTypes[id]
    },
    taskTypes: (state) => {
        var response = Object.values(state.taskTypes)
        return response
    },
    getApprovalCriteriaById: (state) => {
        return (id) => state.approvalCriteria[id]
    },
    approvalCriteria: (state) => {
        var response = Object.values(state.approvalCriteria)
        return response
    }
}
